import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService, IndividualConfig, ActiveToast } from 'ngx-toastr';
import { tap } from 'rxjs/operators';
import { MessageType } from '@models/index.model';

export const showErrorAndSuccess: MessageType[] = [MessageType.ERROR, MessageType.SUCCESS];

export const showErrorAndWarning: MessageType[] = [MessageType.ERROR, MessageType.WARNING];

export const showErrorWarningAndSuccess: MessageType[] = [MessageType.ERROR, MessageType.WARNING, MessageType.SUCCESS];

export const showWarning: MessageType[] = [MessageType.WARNING];

export const showError: MessageType[] = [MessageType.ERROR];

export const showSuccess: MessageType[] = [MessageType.SUCCESS];

@Injectable({
  providedIn: 'root',
})
export class FeedMessageService {
  constructor(private _translate: TranslateService, private _toastr: ToastrService) {}

  /**
   * Displays a toaster to give feedback to the user.
   * @param messageType Message type returned by the HTTP call.
   * @param message Message to display in the toastr.
   * @param display Message types for which the toastr will display.
   * @param toastrConfig Configuration of the custom toastr.
   * @param onAction Callback function that will be executed when the toastr emits an onAction event.
   * @param onCancel Callback function that will be executed then the toastr emits an onCancel event.
   */

  public feedBackResult(
    messageType: MessageType,
    message: string,
    display?: MessageType[],
    toastrConfig?: Partial<IndividualConfig>,
    onAction?: Function,
    onHidden?: Function
  ) {
    if (this._shouldDisplayFeedback(messageType, display)) {
      // Convert MessageType to ResultStatus
      const status: string = MessageType[messageType];
      const title: string = this._translate.instant(`GLOBAL.TOOLTIP.${status}`);
      const level: string = status?.toLowerCase();

      // Call toaster service
      const toastRef: ActiveToast<any> = this._toastr[level](message, title, toastrConfig);

      // Handle custom toast callbacks.
      if (onAction) {
        toastRef.onAction.pipe(tap(actionInfo => onAction(actionInfo))).subscribe();
      }
      if (onHidden) {
        toastRef.onHidden.pipe(tap(_ => onHidden())).subscribe();
      }
    }
  }

  private _shouldDisplayFeedback(messageType: MessageType, display?: MessageType[]): boolean {
    let shouldDisplay: boolean = true;
    if (display) {
      shouldDisplay = display.includes(messageType);
    }
    return shouldDisplay;
  }
}
